// The Introduction's policy (reasons -> areas, profile priors, caps) as
// JSON: edited on a draft, applied once it parses.

import { useState } from "react";
import type { IntroductionPolicy, TalkTrackContent } from "../../types/talkTrack";
import { useUnitContext } from "./unitContext";

export function IntroPolicyEditor({
  content,
  onChange,
}: {
  content: TalkTrackContent;
  onChange: (next: TalkTrackContent) => void;
}) {
  const { editable } = useUnitContext();
  const current = JSON.stringify(content.introduction ?? null, null, 2);
  const [text, setText] = useState(current);
  const [synced, setSynced] = useState(current);
  const [error, setError] = useState<string | null>(null);
  if (current !== synced) {
    setSynced(current);
    setText(current);
    setError(null);
  }

  function edit(next: string) {
    setText(next);
    try {
      const parsed = JSON.parse(next) as IntroductionPolicy | null;
      if (parsed !== null && (typeof parsed !== "object" || Array.isArray(parsed))) {
        throw new Error("The policy is a JSON object.");
      }
      setError(null);
      setSynced(JSON.stringify(parsed, null, 2));
      onChange({ ...content, introduction: parsed });
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    }
  }

  return (
    <fieldset>
      <legend>Introduction policy</legend>
      <p className="muted">
        reasonAreas: Hello reason → areas it raises. priors: "slot=value" or "slot~word" → areas (they only
        reorder open threads). maxAreas, anchorMaxQuestions, softCapTurns, softCapMinutes, hardCapTurns.
        The checks validate it on save.
      </p>
      <textarea className="mono" rows={24} value={text} readOnly={!editable} aria-label="Introduction policy JSON"
        onChange={(e) => edit(e.target.value)} />
      {error && <div className="error-text">Not applied: {error}</div>}
    </fieldset>
  );
}
